export enum PaymentCycle {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  HalfYearly = 'HALF_YEARLY',
  Annual = 'ANNUAL',
}
